/**
 * Generated runtime TestId mirror for frontend/src/pages/ServiceAccountDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ServiceAccountDetailTestIds = {
  apiKeysEmpty: "api-keys-empty",
  apiKeysError: "api-keys-error",
  badgeDetailActiveKeys: "badge-detail-active-keys",
  badgeDetailStatus: "badge-detail-status",
  btnAssignRole: "btn-assign-role",
  btnAssignRoleEmpty: "btn-assign-role-empty",
  btnDeactivateServiceAccount: "btn-deactivate-service-account",
  btnEditServiceAccount: "btn-edit-service-account",
  btnMintApiKey: "btn-mint-api-key",
  btnMintEmpty: "btn-mint-empty",
  btnReactivateServiceAccount: "btn-reactivate-service-account",
  cardApiKeys: "card-api-keys",
  cardApiKeysTitle: "card-api-keys-title",
  cardOverview: "card-overview",
  cardOverviewTitle: "card-overview-title",
  cardRoles: "card-roles",
  cardRolesTitle: "card-roles-title",
  colKeyActions: "col-key-actions",
  colKeyLastUsed: "col-key-last-used",
  colKeyName: "col-key-name",
  colKeyPrefix: "col-key-prefix",
  colKeyRateLimit: "col-key-rate-limit",
  colKeyStatus: "col-key-status",
  colRoleActions: "col-role-actions",
  colRoleAssignedAt: "col-role-assigned-at",
  colRoleAssignedBy: "col-role-assigned-by",
  colRoleDescription: "col-role-description",
  colRoleName: "col-role-name",
  deactivateDialogBody: "deactivate-dialog-body",
  deactivateDialogTitle: "deactivate-dialog-title",
  editDialogTitle: "edit-dialog-title",
  editForm: "edit-form",
  editInputDescription: "edit-input-description",
  editInputName: "edit-input-name",
  rolesEmpty: "roles-empty",
  rolesError: "roles-error",
  rolesLoading: "roles-loading",
  serviceAccountDetailPage: "service-account-detail-page",
  apiKeyName: (key_id: string) => `api-key-name-${key_id}`,
  apiKeyNamePrefix: () => "api-key-name-" as TestIdPrefix,
  apiKeyPrefix: (key_id: string) => `api-key-prefix-${key_id}`,
  apiKeyPrefixPrefix: () => "api-key-prefix-" as TestIdPrefix,
  apiKeyRateLimit: (key_id: string) => `api-key-rate-limit-${key_id}`,
  apiKeyRateLimitPrefix: () => "api-key-rate-limit-" as TestIdPrefix,
  apiKeyRow: (key_id: string) => `api-key-row-${key_id}`,
  apiKeyRowPrefix: () => "api-key-row-" as TestIdPrefix,
  badgeKeyStatus: (apiKey_id: string) => `badge-key-status-${apiKey_id}`,
  badgeKeyStatusPrefix: () => "badge-key-status-" as TestIdPrefix,
  btnRemoveRole: (assignment_roleId: string) => `btn-remove-role-${assignment_roleId}`,
  btnRemoveRolePrefix: () => "btn-remove-role-" as TestIdPrefix,
  btnRevoke: (key_id: string) => `btn-revoke-${key_id}`,
  btnRevokePrefix: () => "btn-revoke-" as TestIdPrefix,
  roleAssignedAt: (assignment_roleId: string) => `role-assigned-at-${assignment_roleId}`,
  roleAssignedAtPrefix: () => "role-assigned-at-" as TestIdPrefix,
  roleAssignedBy: (assignment_roleId: string) => `role-assigned-by-${assignment_roleId}`,
  roleAssignedByPrefix: () => "role-assigned-by-" as TestIdPrefix,
  roleDescription: (assignment_roleId: string) => `role-description-${assignment_roleId}`,
  roleDescriptionPrefix: () => "role-description-" as TestIdPrefix,
  roleLink: (assignment_roleId: string) => `role-link-${assignment_roleId}`,
  roleLinkPrefix: () => "role-link-" as TestIdPrefix,
  roleName: (assignment_roleId: string) => `role-name-${assignment_roleId}`,
  roleNamePrefix: () => "role-name-" as TestIdPrefix,
  roleRow: (assignment_roleId: string) => `role-row-${assignment_roleId}`,
  roleRowPrefix: () => "role-row-" as TestIdPrefix
} as const;
